export default "https://legacy.eskolare-development.com/images/institutions-feature-four.png";